<template>
  <div>
    <el-table
      v-loading="loadTable"
      :data="records"
      stripe
      @sort-change="sort_change"
      :default-sort="{ prop: 'id', order: 'descending' }"
    >
      <el-table-column fixed label="车辆编号" prop="id" />
      <el-table-column label="车主名称" prop="name" />
      <!-- <el-table-column label="分享码" prop="shareCode" /> -->
      <!-- <el-table-column label="联系方式" prop="phone" /> -->
      <el-table-column label="联系方式">
        <template #default="scope">
          {{ scope.row.phone == "0" ? "未绑定" : scope.row.phone }}
        </template>
      </el-table-column>
      <el-table-column label="车库名称">
        <template slot-scope="scope" v-if="scope.row.carport">
          {{ scope.row.carport.name }}
        </template>
      </el-table-column>
      <el-table-column label="车辆类型">
        <template slot-scope="scope" v-if="scope.row.carType">
          {{ scope.row.carType.name }}
        </template>
      </el-table-column>

      <el-table-column label="车辆图片" width="140" align="center">
        <template #default="scope">
          <el-image
            style="width: 80px; height: 80px"
            :src="getCarFullImg(scope)"
            :preview-src-list="getCarPreviewList(scope)"
            fit="fit"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column label="车辆图片" width="140" align="center">
        <template #default="scope">
          <el-image
            style="width: 80px; height: 80px"
            :src="getCarLeftImg(scope)"
            :preview-src-list="getCarPreviewList(scope)"
            fit="fit"
          ></el-image>
        </template>
      </el-table-column>

      <!-- <el-table-column label="楼号" prop="building" />
      <el-table-column label="房号" prop="houseNumber" /> -->
      <el-table-column label="创建时间">
        <template #default="scope">
          {{ timeFormat(scope.row.creatTime) }}
        </template>
      </el-table-column>

      <el-table-column label="操作">
        <template #default="scope">
          <el-button
            size="mini"
            type="primary"
            @click="agentCheckCar(scope.row.id)"
            >通过</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="agentRejectCar(scope.row.id)"
            >驳回</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <page :current="current" :size="size" :total="total" />
    <show-agent-reject-car :device-id="deviceId" :dialog="showAgentRejectCar" />
    <show-agent-check-car :device-id="deviceId" :dialog="showAgentCheckCar" />
  </div>
</template>

<script>
import UserCar from "@/api/device/UserCar";
import Page from "@/components/Page";
import createdMixin from "@/mixin/createMixin";
import dialogMixin from "@/mixin/dialogMixin";
import pageMixin from "@/mixin/pageMixin";
import resDispose from "@/mixin/resDisposeMixin";
import timeMixin from "@/mixin/timeMixin";
import ShowAgentCheckCar from "./comments/ShowAgentCheckCar";
import ShowAgentRejectCar from "./comments/ShowAgentRejectCar";

export default {
  name: "ProxyPowerStationTwo",
  mixins: [pageMixin, createdMixin, timeMixin, resDispose, dialogMixin],
  components: { Page, ShowAgentCheckCar, ShowAgentRejectCar },
  data() {
    return {
      records: [],
      unbindDialog: false,
      showAgentRejectCar: false,
      showAgentCheckCar: false,
      deviceId: undefined,
      params: {
        sortName: "id",
        sortType: "DESC",
      },
      VUE_APP_IMG_FILE_BASE: process.env.VUE_APP_IMG_FILE_BASE,
    };
  },
  methods: {
    getCarFullImg(scope) {
      try {
        return process.env.NODE_ENV === "development"
          ? require("D://www/wwwroot/file.hc17888.com" + scope.row.fullFaceImg)
          : this.VUE_APP_IMG_FILE_BASE + scope.row.fullFaceImg;
      } catch (e) {
        return "";
      }
    },
    getCarLeftImg(scope) {
      try {
        return process.env.NODE_ENV === "development"
          ? require("D://www/wwwroot/file.hc17888.com" + scope.row.leftImg)
          : this.VUE_APP_IMG_FILE_BASE + scope.row.leftImg;
      } catch (e) {
        return "";
      }
    },
    getCarPreviewList(scope) {
      try {
        return process.env.NODE_ENV === "development"
          ? [
              require("D://www/wwwroot/file.hc17888.com" +
                scope.row.fullFaceImg),
              require("D://www/wwwroot/file.hc17888.com" + scope.row.leftImg),
            ]
          : [
              this.VUE_APP_IMG_FILE_BASE + scope.row.fullFaceImg,
              this.VUE_APP_IMG_FILE_BASE + scope.row.leftImg,
            ];
      } catch (e) {
        return [];
      }
    },
    sort_change(e) {
      this.params.sortName = e.prop;
      this.params.sortType = e.order == "descending" ? "DESC" : "ASC";
      if (e.order == null) {
        this.params.sortName = null;
        this.params.sortType = null;
      }
      // console.log(this.params.sortName)
      // console.log(this.params.sortType)
      this.fetchData();
    },
    agentRejectCar(id) {
      this.showAgentRejectCar = true;
      this.deviceId = id;
    },
    agentCheckCar(id) {
      this.showAgentCheckCar = true;
      this.deviceId = id;
    },
    fetchData() {
      this.loadTable = true;
      UserCar.agentGetCarOfNeedCheckByPage({
        pageNum: this.current,
        size: this.size,
        sortName: this.params.sortName,
        sortType: this.params.sortType,
      })
        .then((res) => {
          this.getDataResDispose({
            res,
            success: () => {
              this.records = res.data.records;
              this.total = res.data.total;
              // console.log(this.records)
              this.$emit("fetchDataNum", this.total);
            },
          });
        })
        .finally(() => {
          this.loadTable = false;
        });
    },
  },
};
</script>
